export interface IScorecardDetailsNormalized {
  scorecardId: number;
  scoreAchieved: number;
  totalPossiblePoints: number;
  siteName: string;
  accountName: string;
  agentName: string;
  conversationId: number;
  scorecardName: string;
  version: string;
  startDate: string;
  duration: string;
}

export class ScorecardDetailsNormalizedModel implements IScorecardDetailsNormalized {
  scorecardId: number = 0;
  scoreAchieved: number = 0;
  totalPossiblePoints: number = 0;
  siteName: string = '';
  accountName: string = '';
  agentName: string = '';
  conversationId: number = 0;
  scorecardName: string = '';
  version: string = '';
  startDate: string = '';
  duration: string = '';

  constructor(data?: IScorecardDetailsNormalized) {
    this.scorecardId = data?.scorecardId ?? this.scorecardId;
    this.scoreAchieved = data?.scoreAchieved ?? this.scoreAchieved;
    this.totalPossiblePoints = data?.totalPossiblePoints ?? this.totalPossiblePoints;
    this.siteName = data?.siteName ?? this.siteName;
    this.accountName = data?.accountName ?? this.accountName;
    this.agentName = data?.agentName ?? this.agentName;
    this.conversationId = data?.conversationId ?? this.conversationId;
    this.scorecardName = data?.scorecardName ?? this.scorecardName;
    this.version = data?.version ?? this.version;
    this.startDate = data?.startDate ?? this.startDate;
    this.duration = data?.duration ?? this.duration;
  }
}
